import React from 'react';
import { useVerticalNav } from '../../hooks/useVerticalNav';
import { VerticalTabType } from '../../types/navigation.types';
import { TabButton } from '../TabButton/TabButton';
import { 
    CustomCssIcon, 
    LayoutUIModelIcon, 
    ThemeIcon 
} from 'assests/GmsIcons';

type VerticalNavProps = {
  id?: string;
}

export const VerticalNav = ({ id }: VerticalNavProps) => {
  const baseId = id || 'vertical-nav';
  const { activeTab, setActiveTab } = useVerticalNav();

  const pages = [
    {
      id: 'layout' as VerticalTabType,
      label: 'Layout',
      icon: <LayoutUIModelIcon />
    },
    {
      id: 'css' as VerticalTabType,
      label: 'Custom CSS',
      icon: <CustomCssIcon />
    },
    {
      id: 'theme' as VerticalTabType,
      label: 'Theme',
      icon: <ThemeIcon />
    }
  ];

  return (
    <div id={baseId} data-testid={baseId} className="tw-flex tw-flex-col tw-w-16 tw-bg-white tw-mt-1.5 tw-border-r tw-border-[#D1D1D6] ">
      {pages.map((tab) => (
        <TabButton
          key={tab.id}
          id={`${baseId}-tab-${tab.id}`}
          icon={tab.icon}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => setActiveTab(tab.id)}
        />
      ))}
    </div>
  );
};